import React from "react";
import { SimulationsBody } from "./SimulationsBody";
import SimulationDiagramLoadingIndicator from "./SimulationDiagramLoadingIndicator";
import useStore from "../../../../Store/Store";

interface SimulationBodyCardProps {
  isExpanded: boolean;
  isGeneratingDiagram?: boolean;
  diagramGenerationStartTime?: number;
}

/**
 * Wrapper component that contains the simulation body content
 * when a simulation is selected. Displayed as an expanded card
 * below the selected simulation card.
 */
const SimulationBodyCard: React.FC<SimulationBodyCardProps> = ({
  isExpanded,
  isGeneratingDiagram = false,
  diagramGenerationStartTime,
}) => {
  const { isSimulationFullSizeMode } = useStore((state) => ({
    isSimulationFullSizeMode: state.isSimulationFullSizeMode,
  }));
  if (!isExpanded) return null;

  return (
    <div
      style={{
        width: "92%",
        height: isSimulationFullSizeMode ? "100vh" : "70vh",
        minHeight: isSimulationFullSizeMode ? "100vh" : "70vh",
        maxHeight: isSimulationFullSizeMode ? "100vh" : "70vh",
        borderLeft: "1px solid #e0e0e0",
        borderRight: "1px solid #e0e0e0",
        borderBottom: "1px solid #e0e0e0",
        borderRadius: "0 0 15px 15px",
        overflow: "hidden",
        marginBottom: "10px",
        marginTop: "-1px",
        padding: "8px",
        paddingTop: "12px",
        boxSizing: "border-box",
        position: "relative",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          flex: "1 1 auto",
          position: "relative",
          overflow: "auto",
          visibility: isGeneratingDiagram ? "hidden" : "visible",
        }}
      >
        <SimulationsBody />
      </div>

      {/* Loading indicator overlay - positioned to cover entire card */}
      <SimulationDiagramLoadingIndicator
        isVisible={isGeneratingDiagram}
        startTime={diagramGenerationStartTime}
      />
    </div>
  );
};

export default SimulationBodyCard;
